<mat-card class="about-card">
    <mat-card-header>
        <mat-card-title>LearningML</mat-card-title>
        <mat-card-subtitle>{{'toolbar.about.subtitle' | translate}}</mat-card-subtitle>
    </mat-card-header>
    <img mat-card-image height="300px" src="assets/images/Genio_Maquina-1-1.jpg" alt="LearningML">
    <mat-card-content>
        <p>
            <i>LearningML</i> Copyright © 2020 <a target="_blank" href="http://juandarodriguez.es">Juan David Rodríguez
                García</a> & <a target="_blank" href="https://kgblll.github.io/">KGBL3</a>
        </p>
        <p style="margin: 3px; font-size: small;">English translations thanks to Dave Ames @davidames</p>
        <p style="margin: 3px; font-size: small;">Tradución ao galego grazas a María Loureiro @tecnoloxia</p>
        <p style="margin: 3px; font-size: small;">Traducció al català gràcies a Vicenç Casas (@VicenCasas) i David Muns (@davidmuns)</p>
        <p style="margin: 3px; font-size: small;">Traduzione italiana grazie a Luca Baraldi (@elbilab)</p>
        <p style="margin: 3px; font-size: small;">Deutsche Übersetzung dank Adrian Koegl und Peter Hubwieser</p>
        <p style="margin: 3px; font-size: small;">Ελληνική μετάφραση χάρη στην Κατερίνα Τσαράβα (@k_tsarava)</p>
        <p style="margin: 3px; font-size: small;">Euskarazko itzulpena Beñat Erezumari esker (@BenatErezuma)</p>
        <p style="margin: 3px; font-size: small;">Imagen del genio gracias a <a href="http://robermargan.blogspot.com/p/curriculum-vitae.html">Roberto Marcano Ganzo</a></p>
        <p style="font-size: x-small;">
            This program is free software: you can redistribute it and/or modify it under the terms of the GNU Affero General Public License as published by the Free Software Foundation, either version 3 of the License, or (at your option) any later version. This
            program is distributed in the hope that it will be useful, but WITHOUT ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the GNU Affero General Public License for more details. You
            should have received a copy of the GNU Affero General Public License along with this program. If not, see
            <https://www.gnu.org/licenses/>.
        </p>
        <p style="margin: 3px; font-size: small;">
            <a target="_blank" href="https://gitlab.com/learningml/learningml-editor">editor source code</a> |
            <a target="_blank" href="https://gitlab.com/learningml/learningml-api">server API source code</a> |
            <a target="_blank" href="https://gitlab.com/learningml/learningml-scratch-gui">learningml-scratch-gui</a> |
            <a target="_blank" href="https://gitlab.com/learningml/learningml-scratch-vm">learningml-scratch-vm</a> |
            <a target="_blank" href="https://gitlab.com/learningml/learningml-scratch-l10">learningml-scratch-l10n</a>
        </p>

    </mat-card-content>

</mat-card>